import { resourceCards } from 'constants/InsightsGatheringConstants'

export const ResourceCards = () => (
  <div className="flex flex-wrap gap-4 items-stretch w-full h-full">
    {resourceCards.map(card => (
      <div key={card.number} className="insights-resource-card">
        <p className="subtitle-xl mb-4">{card.title}</p>
        <div className="body-s">{card.content}</div>
        <span
          className={`${card.number === 1 ? 'insights-resource-card-number-one' : 'insights-resource-card-number'}`}
        >
          {card.number}
        </span>
      </div>
    ))}
  </div>
)
